module.exports = __webpack_public_path__ + "static/services-hero-77d31dbfebeb57222cdcc59e8b769d63.png";